import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { WorksheetEntitySummaryIndex } from 'services/worksheet/types';
import { SprayEventStartingRow } from 'services/sprayEvents/types';
import { is2DApplicationType } from 'services/sprayEvents/utils';
import { selectSprayWorksheetEntitySummaries } from '../../../../selectors';
import { Props } from './index';
import { WorkSheetStartingRow } from './types';

const selectEntitySummaryIndex = (
    state: AppState,
    props: Props
): WorksheetEntitySummaryIndex => props.entitySummaryIndex;

const selectStartingRow = createDeepEqualSelector(
    selectSprayWorksheetEntitySummaries,
    selectEntitySummaryIndex,
    (entitySummaries, index) => {
        const startingRow: string = get(entitySummaries, [
            index,
            'startingRow'
        ]);

        const applicationType: string = get(entitySummaries, [
            index,
            'applicationType'
        ]);

        if (is2DApplicationType(applicationType)) {
            return startingRow;
        }

        switch (startingRow.toUpperCase()) {
            case SprayEventStartingRow.DOUBLE.toUpperCase():
                return WorkSheetStartingRow.DOUBLE;
            case SprayEventStartingRow.OUTSIDE.toUpperCase():
                return WorkSheetStartingRow.OUTSIDE;
            case SprayEventStartingRow.ANY.toUpperCase():
            default:
                return WorkSheetStartingRow.ANY;
        }
    }
);

const makeSelectStartingRow = (): typeof selectStartingRow => selectStartingRow;

export { selectEntitySummaryIndex, makeSelectStartingRow };
